<script>
/** Utilities */
import AppResourceUtil from '../utilities/AppResourceUtil'
/** API */
import IssueApi from '../api/IssueApi'
import AnnouncementApi from '../api/AnnouncementApi'

export default {
    name : "LoginAnnouncements",
    data(){
        return {
            globalLoading: null,
            posts: []
        }
    },
    created(){
        this.getAnnouncements()
    },
    mounted() {
        setTimeout(() => {
            var html = document.getElementById('orehtml')
            html.style.overflowY = 'hidden';
        },1000)
    },
    methods: {
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            if (this.globalLoading !== null) {
                this.globalLoading.close()
            }
            this.globalLoading = null
        },
        getAnnouncements() {
            this.posts = []
            this.showLoading()
            AnnouncementApi.get()
            .then(response=>{
                this.closeLoading()
                let posts = response.data;
                if (response.data) {
                    if (!response.data.error) {
                        if (posts.length > 0) {
                            posts.forEach(post=>{
                                if (post.postBody) {
                                    post.htmlMessage = post.postBody.replace(/(?:\r\n|\r|\n)/g, '<br />');
                                }
                                if (post.postBody.length > 25) {
                                    post.excerpt = post.postBody.substr(0,24)+'...'
                                } else {
                                    post.excerpt = post.postBody
                                }
                                post.dateCreated = AppResourceUtil.convertDate(post.dateCreated)
                                post.datePosted = AppResourceUtil.convertDate(post.datePosted)
                                post.dateLastUpdated = AppResourceUtil.convertDate(post.dateLastUpdated)
                            })
                        }
                        this.posts = posts
                    }
                    else {
                        this.promptServerError({response},'Announcement.get');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Announcement.get');
                this.closeLoading()
            });
        },
        closeError(){
            this.errorData = null;
        },
        logOut(){
            this.$router.push({path:"/login"});
        },
        resetErrorMessage(){
            this.errorData = null;
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        submitError(errorData,api){

            let obj = {
                email : '',
                username : '',
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        }
    }
}
</script>

<template>
    <div> 
        <p class="has-text-weight-semibold has-text-white"
            style="margin:0.5rem;">Announcements ({{posts.length}})</p>
        <div class="announcement-column-content">
            <div v-if="posts.length > 0"
                class="announcement-holder">
                <ul style="margin:1rem 0.7rem 0 0;">
                    <li v-for="post in posts"
                        v-bind:key="post.postId">
                        <div class="box"
                            style="margin:0.7rem 0 0.7rem 0.1rem">
                            <p class="has-text-grey caption">Date Posted: {{post.datePosted}}</p>
                            <div class="content">
                                <div v-html="post.htmlMessage"></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-else
                class="has-text-left is-small has-text-white has-text-left"
                style="margin:0.4rem auto;max-width:98%;height:100vh">
                <span>No data found.</span>
            </div>
        </div>
    </div>
</template>

<style scoped>
.announcement-column-content {
    height:100vh;
    max-width: 73vw;
}
.announcement-holder {
    margin-bottom:1rem;
    max-height: 82vh;
    min-height: 80vh;
    overflow-y:scroll;
}
.caption {
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginAnnouncements.vue